import { EFieldNames } from '@shared/models/Enums/EFieldNames';
import { FormFieldModel } from '@shared/models/LoginModels/FormFieldModel';
import { required, email, minLength, maxLength, numeric } from 'vuelidate/lib/validators';

export interface ParentSignUpModel {
  [EFieldNames.FirstName]: string;
  [EFieldNames.LastName]: string;
  [EFieldNames.Email]: string;
  [EFieldNames.Phone]: string;
  [EFieldNames.Password]: string;
  [EFieldNames.Address]: string;
  [EFieldNames.Policy]: boolean | null;
  [EFieldNames.Country]: string;
  [EFieldNames.City]: string;
  [EFieldNames.State]: string;
  [EFieldNames.Zip]: string;
}

export const signupParentModel: ParentSignUpModel = {
  [EFieldNames.Email]: '',
  [EFieldNames.Phone]: '',
  [EFieldNames.Password]: 'Asd_asd!1',
  [EFieldNames.FirstName]: '',
  [EFieldNames.LastName]: '',
  [EFieldNames.Address]: '',
  [EFieldNames.Country]: '',
  [EFieldNames.City]: '',
  [EFieldNames.State]: '',
  [EFieldNames.Zip]: '',
  [EFieldNames.Policy]: null,
};

export const signupParentFields: { [key: string]: FormFieldModel } = {
  [EFieldNames.Email]: {
    label: 'Email',
    icon: 'mdi-email-outline',
    errors: {
      required: 'Email is required',
      email: 'Email is not valid',
    },
  },
  [EFieldNames.Phone]: {
    label: 'Phone number',
    icon: 'mdi-phone-outline',
    errors: {
      required: 'Phone number is required',
      numeric: 'Phone number allows digits only.',
      maxLength: 'Max number of symbols in phone is 15.',
    },
  },
  [EFieldNames.FirstName]: {
    label: 'First name',
    icon: 'mdi-account-outline',
    errors: {
      minLength: 'Min number of symbols in first name is 2',
      maxLength: 'Max number of symbols in first name is 64',
      required: 'First name is required',
    },
  },
  [EFieldNames.LastName]: {
    label: 'Last name',
    icon: 'mdi-account-outline',
    errors: {
      minLength: 'Min number of symbols in last name is 2',
      maxLength: 'Max number of symbols in first name is 64',
      required: 'Last name is required',
    },
  },
  [EFieldNames.Address]: {
    label: 'Street address',
    icon: 'mdi-map-marker-outline',
    errors: {
      required: 'Street address is required',
    },
  },
  [EFieldNames.City]: {
    label: 'City',
    errors: {
      required: 'City is required',
    },
  },
  [EFieldNames.Country]: {
    label: 'Country',
    errors: {
      required: 'Country is required',
    },
  },
  [EFieldNames.State]: {
    label: 'State/Province',
    style: 'width: 49%; margin-right: 1%;',
    className: 'd-inline-flex',
    errors: {
      required: 'Province is required',
    },
  },
  [EFieldNames.Zip]: {
    label: 'Postal code',
    style: 'width: 49%; margin-left: 1%;',
    className: 'd-inline-flex',
    errors: {
      required: 'Postal code is required',
    },
  },
  [EFieldNames.Policy]: {
    label: `Creating an account means you agree to our </br>
      <a href='/terms' class='black--text'>Terms of Service</a>,
      <a href='/policy' class='black--text'>Privacy Policy</a>`,
    type: 'checkbox',
    errors: {
      required: 'Privacy Policy is required',
    },
  },
};

export const signupParentFieldsValidation = {
  [EFieldNames.Email]: {
    required,
    email,
  },
  [EFieldNames.Phone]: {
    required,
    numeric,
    maxLength: maxLength(15),
  },
  [EFieldNames.FirstName]: {
    required,
    minLength: minLength(2),
    maxLength: maxLength(64),
  },
  [EFieldNames.LastName]: {
    required,
    minLength: minLength(2),
    maxLength: maxLength(64),
  },
  [EFieldNames.Address]: {
    required,
  },
  [EFieldNames.Country]: {
    required,
  },
  [EFieldNames.City]: {
    required,
  },
  [EFieldNames.State]: {
    required,
  },
  [EFieldNames.Zip]: {
    required,
  },
  [EFieldNames.Policy]: {
    required,
  },
};
